var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 10.0615C20.0001 4.50402 15.5226 -0.000976562 10.0001 -0.000976562C4.47506 0.000273438 -0.00244141 4.50402 -0.00244141 10.0628C-0.00244141 15.084 3.65506 19.2465 8.43506 20.0015V12.9703H5.89756V10.0628H8.43756V7.84402C8.43756 5.32277 9.93131 3.93027 12.2151 3.93027C13.3101 3.93027 14.4538 4.12652 14.4538 4.12652V6.60152H13.1926C11.9513 6.60152 11.5638 7.37777 11.5638 8.17402V10.0615H14.3363L13.8938 12.969H11.5626V20.0003C16.3426 19.2453 20.0001 15.0828 20.0001 10.0615Z",
    fill: "#3E64C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f75b52a73d846f2bc2ea69ff3813829d.svg";
export { ForwardRef as ReactComponent };